// ProPage.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faHistory, faCrosshairs, faVault, faCrown } from '@fortawesome/free-solid-svg-icons';
import '../StylesComponents/pro-page.css';

function ProPage({ currentUser }) {
  const handleUpgrade = async () => {
    if (!currentUser) {
      window.location.href = '/signup?plan=pro';
      return;
    }
    window.location.href = '/profile';
  };

  return (
    <div className="pro-page-container">
      <div className="pro-hero-section">
        <div className="pro-badge-large">AUTHORIZE_LEVEL_2</div>
        <h1 className="pro-title">STOCKROOM_PRO</h1>
        <div className="pro-price-tag">$4.99 / Month</div>
        
        {currentUser?.subscription?.status === 'pro' ? (
          <div className="active-sub-badge" style={{ color: 'var(--color-savings)', fontWeight: '900', fontSize: '18px' }}>
            <FontAwesomeIcon icon={faCrown} style={{ marginRight: '10px' }} />
            STATUS: ACTIVE_SUBSCRIBER
          </div>
        ) : (
          <button className="upgrade-btn-pro" onClick={handleUpgrade}>
            UPGRADE
          </button>
        )}
      </div>

      <div className="pro-features-grid">
        <div className="pro-feature-card">
          <div className="pro-feature-icon"><FontAwesomeIcon icon={faBolt} /></div>
          <h3 className="pro-feature-title">THE_SIGNAL</h3>
          <p className="pro-feature-desc">
            Information is currency. Receive a high-priority 3-hour window on all new market drops. Access the deepest markdowns before inventory hits the public domain and sizes sell out.
          </p>
        </div>

        <div className="pro-feature-card">
          <div className="pro-feature-icon"><FontAwesomeIcon icon={faHistory} /></div>
          <h3 className="pro-feature-title">MARKET_HISTORY</h3>
          <p className="pro-feature-desc">
            Never overpay again. Visualize the full pricing timeline of any product with technical data charts. Verify if a current markdown is a legitimate record low or just a temporary pulse.
          </p>
        </div>

        <div className="pro-feature-card">
          <div className="pro-feature-icon"><FontAwesomeIcon icon={faCrosshairs} /></div>
          <h3 className="pro-feature-title">AUTO_SNIPE</h3>
          <p className="pro-feature-desc">
            Deploy a custom monitoring node. Lock in specific brands and sizes with a target discount threshold. Our engine monitors the market 24/7 and alerts you the millisecond a match is detected.
          </p>
        </div>

        <div className="pro-feature-card">
          <div className="pro-feature-icon"><FontAwesomeIcon icon={faVault} /></div>
          <h3 className="pro-feature-title">THE_VAULT</h3>
          <p className="pro-feature-desc">
            The ultimate stack. Gain unrestricted access to a hidden database of active, stackable discount codes. Combine our discovered deals with exclusive Pro codes for maximum reduction.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProPage;
